<template>
  <section class="d-flex flex-column h-100 justify-content-center">
    <div class="container">
      <div class="row">
        <div class="col-12 col-sm-8 offset-sm-2 col-lg-6 offset-lg-3">

          <div class="text-center mb-4 d-none d-lg-block">
            <img class="company-logo" src="/images/logo_emotivi.png" alt="" />
          </div>

          <div class="p-3">
            <h3 class="text-uppercase text-center">
              Gérer votre abonnement
            </h3>
            <div class="mt-2">
              <div class="form-floating">
                <input
                  type="text"
                  class="form-control"
                  id="co_login"
                  name="co_login"
                  placeholder="Adresse email"
                  v-model="co_login"
                  required
                />
                <label for="co_login">Identifiant </label>
              </div>
              <div class="form-floating mt-4">
                <input
                  type="password"
                  class="form-control"
                  id="co_password"
                  name="co_password"
                  placeholder="Mot de passe"
                  v-model="co_password"
                  required
                />
                <label for="co_password">Mot de passe</label>
              </div>
              
              <div v-if="dialogErrTxt" class="alert alert-danger mt-3" v-html="dialogErrTxt"></div>

              <div class="text-end mt-1">
                <a @click="resetPassword()" href="javascript:void(0);">
                  Mot de passe oublié
                </a>
              </div>

              <div class="text-end mt-3">
                <button type="button" class="btn btn-lg btn-primary" @click="login()" style="width:100%;">
                  Se connecter
                </button>
              </div>
            </div>
          </div>

          <hr width="50%" class="center mt-4 mb-3">

          <p class="text-center">
            <a href="https://webapp.emotivi.io">
              Aller à l'application Emotivi
            </a>
          </p>

        </div>

        <div id="modalResetPassword" class="modal fade" role="dialog">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-body p-4">
                  Un email vous a été envoyé afin de changer votre mot de
                  passe.
              </div>
              <div class="modal-footer text-end">
                <button class="btn btn-primary" type="button" data-bs-dismiss="modal">
                  Ok
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import { Modal } from "bootstrap";

export default {
  name: "login",
  components: {},
  data() {
    return {
      co_login: "",
      co_password: "",
      dialogErrTxt: "",
      resetPwdModal: undefined
    };
  },
  mounted() {
    this.resetPwdModal = new Modal('#modalResetPassword');
    this.resetPwdModal.hide();
  },
  methods: {

    connectWebapp() {
      this.$Utils.openWebappSite();
    },

    async resetPassword() {

      this.dialogErrTxt = "";

      this.resetPwdModal.hide();
    
      if (this.co_login) {

        try {
          let response = await this.$axios.post(
            this.$config.server_url + "/web/2.0/signin/forgetpassword",
            { co_login: this.co_login }
          );

          if (response.data.err) {
            try {
              let response2 = await this.$axios.post(
                "https://api.emotivi.fr/web/1.0/sendResetPasswordMail",
                { login: this.co_login, emotivi_web: true }
              );
              if (response2 && response2.data.email) {
              } else {
                this.dialogErrTxt =
                  "L'adresse email que vous avez rentré n'existe pas.";
                return;
              }
            } catch (error) {
              this.dialogErrTxt =
                "L'adresse email que vous avez rentré n'existe pas.";
              return;
            }
          }

          this.resetPwdModal.show();

        } catch (err) {

          console.error("error", err);
          this.dialogErrTxt =
            "Un problème est survenu. Veuillez réessayer dans quelques minutes.";

        }
      } else {
        this.dialogErrTxt =
          "Veuillez rentrer votre adresse email pour changer votre mot de passe.";
      }
    },

    goToSubscription() {
      window.open(this.$config.web_url_subscription, "_self");
    },

    async newpassword() {
      //if (!this.challenge_newpassword) return;
      /*** vérification du mot de passe */
      if (!this.co_password1 || !this.co_password2) {
        this.dialogErrTxt = "Vous devez choisir un mot de passe";
        this.dialogErr = true;
      }
      if (this.co_password1 !== this.co_password2) {
        this.dialogErrTxt = "les mots de passe doivent être identiques";
        this.dialogErr = true;
      }
      if (!this.dialogErr) {
        let response = await this.$axios.post(
          this.$config.server_url +
            "/web/2.0/signin/forgetpassword/newpassword",
          {
            co_password: this.co_password1,
            co_id: this.co_id,
            challenge: this.challenge_newpassword
          }
        );
        if (response.data.err) {
          this.alert_txt_part4 = "Erreur";
        } else {
          this.currentPart = "part5";
        }
      }
    },
    async checkchallenge(co_id, challenge) {
      this.co_id = co_id;
      let response = await this.$axios.post(
        this.$config.server_url +
          "/web/2.0/signin/forgetpassword/checkchallenge",
        { co_id, challenge }
      );
      if (response.data.err) {
        this.alert_txt_part4 = "Erreur - Cette page n'est plus accessible";
      } else {
        // this.currentPart = "part3";
        this.challenge_newpassword = response.data.data.challenge;
      }
    },
    async sendPassword() {
      let response = await this.$axios.post(
        this.$config.server_url + "/web/2.0/signin/forgetpassword",
        { co_login: this.co_login }
      );
      if (response.data.err) {
        this.alert_txt_part2 =
          "Nous n'avons pas pu retrouver votre identifiant";
      } else {
        this.currentPart = "part3";
      }
    },

    async login() {
      this.dialogErrTxt = "";
      try {
        let response = await this.$axios.post(
          this.$config.server_url + "/web/2.0/signin",
          { co_login: this.co_login, co_password: this.co_password }
        );
        // console.log("response.data", response.data);
        if (response.data.err) {
          if (response.data.err.key == "no_caution_paid") {
            this.dialogErrTxt = `Vous n'avez pas fini l'inscription et le paiement. Veuillez reprendre l'inscription dans <a href="${this.$config.web_url_subscription}">Commander votre kit</a>`;
            return;
          }

          // check V1
          let responseV1 = await this.$axios.post(
            this.$config.server_url_v1 + "/web/1.0/login",
            { co_email_family: this.co_login, co_password: this.co_password }
          );
          if (responseV1.data) {
            //console.log("logged : ", responseV1.data);
            // if (response.data.co_refresh_token_emotivi) {
            //    localStorage.setItem('co_refresh_token_emotivi', response.data.co_refresh_token_emotivi);
            // }

            document.cookie =
              "domain=" +
              this.$config.web_v1 +
              ";co_refresh_token_emotivi=" +
              responseV1.data.co_refresh_token_emotivi;

            document.cookie =
              "domain=" +
              this.$config.web_v1 +
              ";co_token_emotivi=" +
              responseV1.data.co_token_emotivi;

            return window.open(this.$config.web_v1 + "/account", "_self");
          } else {
            this.dialogErrTxt =
              "Un problème est survenu. Votre identifiant ou votre mot de passe est incorrect.";
          }
          return;
        }
        // this.alert_txt = "Vous êtes connecté";
        // this.alert_type = "success";
        // this.$store.commit("set_token", response.data.accesstoken);
        // this.$store.commit("set_refreshtoken", response.data.refreshtoken);
        // this.$store.commit("set_user", response.data.data);
        this.$store.commit("set_connexion", {
          accesstoken: response.data.data.accesstoken,
          // refreshtoken: response.data.refreshtoken,
          user: response.data.data.row,
          preferences: response.data.data.preferences
        });
        //   this.$root.$children[0].showMenus();
        this.$router.push("/private/payments");
      } catch (error) {
        console.error("error", error);
        this.dialogErrTxt =
          "Un problème est survenu. Votre identifiant ou votre mot de passe est incorrect.";

        // this.alert_txt = "Erreur!!!";
        // this.alert_type = "warning";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.company-logo {
	max-height: 90px;
}
.center {
    margin: 0 auto;
}
.img-fluid {
  width: 100%;
  height: auto;
}
.container2-form-login {
  width: 80%;
}
.links {
  align-items: flex-end;
}
</style>
